import { render, staticRenderFns } from "./ReturnDealerBike.vue?vue&type=template&id=481ece10"
import script from "./ReturnDealerBike.vue?vue&type=script&lang=js"
export * from "./ReturnDealerBike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports